import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import type { Dispatch, RootState } from '@/models/store';
import { Drawer } from 'antd-v5';
import styles from './index.module.less';
import { getAppRootDom } from '@/App';
import { useCallback } from 'react';

type TProps = {
  drawerVisible: boolean;
  hideDrawer?: () => void;
  closable?: boolean;
};

export default (props: TProps) => {
  const countryList: any = useSelector<RootState>(
    state => state.LocaleModel.countryList,
    shallowEqual
  );

  const dispatch = useDispatch<Dispatch>();

  const getHostName = useCallback(
    (countryCode: string) => {
      if (countryCode === 'CN') {
        return dispatch.GlobalModel.getHostName({});
      } else {
        return dispatch.GlobalModel.getGlobalHostName({});
      }
    },
    [dispatch.GlobalModel]
  );

  return (
    <Drawer
      open={props.drawerVisible}
      onClose={props.hideDrawer}
      closable={props.closable}
      getContainer={getAppRootDom}
      className={styles['sideLanguagesBar']}
    >
      {(countryList ?? []).map(item => (
        <li className={styles['sideLanguagesBar-module']}>
          <span className={styles['sideLanguagesBar-module-item']}>
            <img src={item.countryIcon} />
            <span>{item.countryName}</span>
          </span>
          <div className={styles['sideLanguagesBar-module-languages']}>
            {(item.langList ?? []).map((lang, i) =>
              i === 0 ? (
                <a
                  href={`https://${getHostName(item.countryCode)}/${item.countryCode}`}
                  target='_self'
                >
                  {lang.langName}
                </a>
              ) : (
                <a
                  href={`https://${getHostName(item.countryCode)}/${item.countryCode}/${
                    lang.langCode
                  }`}
                  target='_self'
                >
                  <span className={styles['sideLanguagesBar-module-languages-separator']} />
                  {lang.langName}
                </a>
              )
            )}
          </div>
        </li>
      ))}
    </Drawer>
  );
};
